import {
  adminAddUser,
  adminDeleteUser,
  adminPutUser,
  adminUserList,
} from "@/api/mods/admin";
import { useState } from "react";
import { Form } from "antd";
import log from "loglevel";
import { adminControllerGetList } from "@/services/ant-design-pro/admin";

export default function UserManagementStoreModel() {
  const [UMData, setUMDate] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [size] = useState(10);
  const [total, setTotal] = useState(0);
  const [formRef] = Form.useForm();
  const [formData, setFormDatas] = useState([]);
  const [addUser, setAddUser] = useState({
    title: "",
    titleDefault: "",
    visible: false,
  });

  const [editorData, setEditorData]: any = useState(null);

  // 获取 用户列表
  const getUserManagementList = async (data?: any) => {
    try {
      const res: any = await adminControllerGetList(data);
      setUMDate(res.results);
      setPage(res.page);
      setTotal(res.total);
    } catch (e) {
      log.info(e);
    }
  };

  // 添加用户
  const addUserApi = async (param: any) => {
    try {
      const res = await adminAddUser(param);
      if (res.status === 200) {
        await getUserManagementList({ page, size });
        setAddUser({
          ...addUser,
          visible: false,
        });
        return true;
      }
      return false;
    } catch (e) {
      log.error(e);
      return false;
    }
  };

  // 删除用户
  const deleteUserApi = async (data: {
    userId: {
      phone: string;
      username: string;
      password: string;
      role: "SUPER_ADMIN" | "ADMIN" | "OFFICER" | "REPORTER";
      email: string;
      name: string;
      centers?: string[];
    };
  }) => {
    try {
      const res = await adminDeleteUser(data.userId);
      if (res.status === 200) {
        await getUserManagementList({ page, size });
        return true;
      }
      return false;
    } catch (e) {
      log.error(e);
      return false;
    }
  };

  // 编辑 用户
  const editorUser = async (data: {
    phone: string;
    username: string;
    password: string;
    role: "SUPER_ADMIN" | "ADMIN" | "OFFICER" | "REPORTER";
    email: string;
    name: string;
    centers?: string[];
  }) => {
    try {
      const res = await adminPutUser(editorData.userId, data);
      if (res.status === 200) {
        await getUserManagementList({ page, size });
        setAddUser({
          title: "user.management.page.editor.user.title",
          titleDefault: "编辑用户",
          visible: false,
        });
        return true;
      }
      return false;
    } catch (e) {
      log.error(e);
      return false;
    }
  };
  return {
    UMData,
    getUserManagementList,
    addUserApi,
    page,
    size,
    addUser,
    setAddUser,
    deleteUserApi,
    total,
    setEditorData,
    editorData,
    formRef,
    formData,
    setFormDatas,
    editorUser,
  };
}
